import { Component, Input } from '@angular/core';
import { Icon } from '../../../redesign/icon/models/icon.model';

export interface IModalList {
  icon: string | Icon;
  label: string;
}

@Component({
  selector: 'app-modal-list-with-icon',
  templateUrl: './modal-list-with-icon.component.html',
  styleUrls: ['./modal-list-with-icon.component.scss']
})
export class ModalListWithIconComponent {
  @Input() data: IModalList[] = [];
  @Input() borderOnAllItems: boolean = false;

  usesIconComponent (item: IModalList): boolean {
    return typeof item.icon !== 'string';
  }
}
